import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { Amplify } from 'aws-amplify';
import { CookieStorage, Hub } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { bootstrapApplication } from '@angular/platform-browser';
import { HttpBackend, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { AppComponent } from './app/app.component';
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { provideLoginService } from 'login';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { provideRouter } from '@angular/router';
import routes from './app/app-routing.module';
import { debugAuth, isAuthDebugEnabled } from './app/debug/auth-debug';

interface AuthHubEvent {
  payload: {
    event: string;
    data?: string;
  };
}

if (environment.production) {
  enableProdMode();
}

debugAuth('bootstrap start', {
  production: environment.production,
  loginHost: environment.loginHost,
  url: window.location.href,
  debugEnabled: isAuthDebugEnabled()
});

Hub.listen('auth', (data: AuthHubEvent) => {
  // User has just been authenticated. Check to see if redirect url was provided and, if so, redirect.
  debugAuth('Hub auth event', {
    event: data.payload.event,
    hasData: Boolean(data.payload.data),
    data: data.payload.data
  });
  if (data.payload.event !== 'customOAuthState' || !data.payload.data) { return; }
  window.location.href = data.payload.data;
});

// Configure amplify
Amplify.configure({ Auth: { Cognito: environment.cognitoConfig } });
// eslint-disable-next-line no-magic-numbers
const rootDomain = location.hostname.split('.').reverse().splice(0, 2).reverse().join('.');
cognitoUserPoolsTokenProvider.setKeyValueStorage(new CookieStorage({ sameSite: 'none', domain: rootDomain, secure: true }));

bootstrapApplication(AppComponent, {
  providers: [
    provideNoopAnimations(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    provideTranslateService({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    provideLoginService({
      licenseServerUrl: environment.licensing_server
    })
  ],
}).catch((err: unknown) => console.error(err));

function HttpLoaderFactory(handler: HttpBackend): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(handler, [
    { prefix: './assets/i18n/', suffix: '.json' }
  ])
}